import { useRequestForQuotesSearchLazyQuery } from '@/buyers/_gen/gql'
import useGqlClient from '@/buyers/hooks/useGqlClient'
import { useEffect, useMemo } from 'react'
import useSession from './useSession'

const useDuplicateRfqs = (
  machineId: string | undefined,
  partNumbers: string[],
  ignoreRfqIds?: string[]
) => {
  const { orgId } = useSession()

  const [getDuplicateRfqs, { data }] = useRequestForQuotesSearchLazyQuery({
    client: useGqlClient(),
  })

  useEffect(() => {
    if (machineId && partNumbers.length > 0 && partNumbers[0] !== '') {
      const filter = JSON.stringify([
        ['machine_id_eq', machineId || ''],
        ...partNumbers.map((partNumber) => ['part_mpn_contains', partNumber]),
      ])

      getDuplicateRfqs({ variables: { orgId, filter } })
    }
  }, [machineId, partNumbers])

  const duplicateRfqs = useMemo(() => {
    const duplicatedRequests =
      data?.searchRequests.requests.map((rfq) => ({
        id: rfq.id,
        name: rfq.user ? rfq.user.displayName : '(unknown)',
      })) || []

    return ignoreRfqIds
      ? duplicatedRequests.filter(({ id }) => !ignoreRfqIds.includes(id))
      : duplicatedRequests
  }, [data?.searchRequests.requests])

  return duplicateRfqs
}

export default useDuplicateRfqs
